import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";

import {
  ICheckoutSubscriptionBenefitsItem,
  ISubscriptionAttachment,
  SubscriptionAttachmentType,
} from "web/types/Subscription";

interface ICheckIfReadMoreShouldBeDisplayedArgs {
  visibleDescription: ICheckoutSubscriptionBenefitsItem["visibleDescription"];
  attachments: ISubscriptionAttachment[];
}

const checkIfReadMoreShouldBeDisplayed = ({
  visibleDescription,
  attachments,
}: ICheckIfReadMoreShouldBeDisplayedArgs) =>
  visibleDescription ||
  (isArrayHasItems(attachments) &&
    !!attachments.filter(
      ({ type }) => type !== SubscriptionAttachmentType.PDF_BARCODE
    ).length);

export default checkIfReadMoreShouldBeDisplayed;
